// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".showdownloadmessage[data-v-b142ca28] {\n  height: 85vh;\n}\n.showdownloadmessage iframe[data-v-b142ca28] {\n  width: 100%;\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
